import React, { useEffect, useRef } from "react";
import { SimpleLoader } from "./sub/Loaders";
import TopPlanElement from "./TopPlanElement";

function TopPlanTreeCards(props) {
  const BottomRef = useRef(null);

  useEffect(() => {
    if (props.data?.length > 0) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            !props.loading &&
            props.totalTopPlanCount > props.data.length
          ) {
            props.setStartAt(props.startAt + 20);
            props.loadMore(props.startAt + 20);
          }
        });
      });
      observer.observe(BottomRef.current);
      return () => observer.disconnect();
    }
  }, [props]);

  return (
    <>
      {props.data?.map((element, index) => (
        <React.Fragment key={element.planId}>
          <TopPlanElement
            plans={props.data}
            data={element}
            handleDelete={props.handleDelete}
            handleEdit={props.handleEdit}
          />
          {index === props.data.length - 1 && <div ref={BottomRef} />}
        </React.Fragment>
      ))}

      {props.loading && <SimpleLoader />}
    </>
  );
}

export default TopPlanTreeCards;
